import { GET_USERS_ACTIVITY_FAILURE, GET_USERS_ACTIVITY_REQUEST, GET_USERS_ACTIVITY_SUCCESS, GetUsersActivityActionTypes, GetUsersActivityState } from './types';

const defaultState: GetUsersActivityState = {
  isLoading: false,
  errorMessage: "",
};

export default function getUsersActivity(state = defaultState, action: GetUsersActivityActionTypes): GetUsersActivityState {
  switch (action.type) {
    case GET_USERS_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_USERS_ACTIVITY_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_USERS_ACTIVITY_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
